import { IntSpiIfi, spiCuentaBanco } from './../../_model/spi/spi';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { config } from "../../../../environments/config";
import { Router } from "@angular/router";
import { Spi } from "../../_model/spi/spi";
import { AuthenticationService } from 'app/auth/service';
import { User } from 'app/auth/models/user';
import { AlertService } from '../alert/alert.service';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SpiService {
    public currentUser: User;
    mensaje: any;
    private mensajero = new ReplaySubject<any>()
    private transferenciainterna = new ReplaySubject<any>()
    private cuentabanco = new ReplaySubject<any>()
    private nombanco = new ReplaySubject<any>()
    //public
    public currentSpi: Observable<User>;

    //private
    private currentSpiSubject: BehaviorSubject<any>;

    constructor(
        private router: Router,
        private http: HttpClient,
        private _authenticationService: AuthenticationService,
        private alertService: AlertService,
    ) {
        this._authenticationService.currentUser.subscribe(x => (this.currentUser = x));
        this.currentSpiSubject = new BehaviorSubject<any>('');
        this.currentSpi = this.currentSpiSubject.asObservable();
    }

    /*
    transferencia interna
     */
    public recibeTranferenciaInterna(event: any) {
        //console.log(event);
        this.transferenciainterna.next(event);
    }

    public get eviaTranferenciaInterna() {
        return this.transferenciainterna.asObservable()
    }

    /*
    tranferencia interbancaria
     */
    public enviarMensaje(mensaje: any) {
        //console.log(mensaje)
        this.mensajero.next(mensaje);
    }
    public get recibir() {
        return this.mensajero.asObservable()
    }

    /*
    bancos
     */
    public recibeCuentaBanco(event: string) {
        //console.log(event);
        this.cuentabanco.next(event);
    }

    public get recibircuenta() {
        return this.cuentabanco.asObservable();
    }


    eliminarSpiBancos(cuenta: spiCuentaBanco) {
        const params = new HttpParams()
            .set('token', this.currentUser.list)
            .set('secuencial', '' + cuenta.id.codSecuencial);
        return this.http.post<any>(`${config.apiUrl}/web/spi/cuenta/delete`, params)
            .toPromise()
            .then(res => <spiCuentaBanco>res)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }

    createSpiBancos(data: any) {
        // console.log(data)
        const params = {
            "id": null,
            "corte": null,
            "token": [this.currentUser.list],
            "status": 0,
            "message": "",
            "data": [
                {
                    id: {
                        codSecuencial: 0,
                        codSocio: 0
                    },
                    codCuentaBceRecibe: data.value.entidad.cod_cuenta_bce,
                    fecRegistro: new Date(),
                    codCuentaRecibe: data.value.cuentabanco,
                    codTipoCuentaRecibe: data.value.tipocuentarecibe,
                    nomOrdenante: data.value.nombeneficiario,
                    nomBeneficiario: data.value.nombeneficiario,
                    numIdBeneficiario: data.value.identificacion,
                    txtInstrucciones: "null",
                    stsWebSpiCuenta: "A"
                }
            ]
        };
        return this.http.post<any>(`${config.apiUrl}/web/spi/cuenta/create2`, params)
            .toPromise()
            .then(res => <any>res)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }

    NCInterna(formdata) {
        console.log(formdata)
        const params = new HttpParams()
            .set('token', this.currentUser.list)
            .set('monto', formdata.monto)
            .set('producto', formdata.cuenta.id.codProducto)
            .set('cuenta', formdata.cuenta.id.codCuenta)
            .set('productosocio', formdata.producto.codProducto)
            .set('cuentasocio', formdata.cuentaacreditar)
            .set('descripcion', formdata.descripcion);
        return this.http.post<any>(`${config.apiUrl}/ahorros/nctransferencia`, params)
            .toPromise()
            .then(res => <any>res)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }

    NCInterbancaria(formdata) {
        console.log(formdata)
        const params = new HttpParams()
            .set('token', this.currentUser.list)
            .set('monto', formdata.monto)
            .set('producto', formdata.producto.id.codProducto)
            .set('cuenta', formdata.producto.id.codCuenta)
            .set('banco', formdata.entidad)
            .set('identificacion', formdata.identificacion)
            .set('beneficiario', formdata.nombeneficiario)
            .set('tipocuenta', formdata.tipocuentaenvia)
            .set('ctaacreditar', formdata.cuentabanco)
            .set('descripcion', formdata.descripcion)
            .set('spiconcepto', formdata.concepto)
            .set('tipocuentaacreditar', formdata.tipocuentarecibe);
        return this.http.post<any>(`${config.apiUrl}/spi/create`, params)
            .toPromise()
            .then(res => <any>res)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }

    findAllBancos() {
        return this.http.get<any>(`${config.apiUrl}/ifi/listar`)
            .toPromise()
            .then(res => <IntSpiIfi[]>res.data)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }

    listarBancos() {
        return this.http.get<any>(`${config.apiUrl}/ifi/listar`)
            .toPromise()
            .then(res => <any>res.data)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }

    buscarBancos(cuenta) {
        const params = new HttpParams()
            .set('cuentabce', cuenta);
        return this.http.post<any>(`${config.apiUrl}/ifi/filter`, params)
            .toPromise()
            .then(res => <any>res.data)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }


    buscarMisCuentas() {
        const params = new HttpParams()
            .set('token', this.currentUser.list);
        return this.http.post<any>(`${config.apiUrl}/web/spi/cuenta/filter`, params)
            .toPromise()
            .then(res => <any>res.data)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }


    listarConcepto() {
        return this.http.get<any>(`${config.apiUrl}/spiconcepto/listar`)
            .toPromise()
            .then(res => <any>res.data)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }

    getComprobantes(token: string, oficina, transaccion, numtransaccion) {
        const params = {
            "id": null,
            "corte": null,
            "token": [token],
            "status": 0,
            "message": "",
            "data": [
                {
                    "codOficina": oficina,
                    "codTransaccion": transaccion,
                    "num_transaccion": numtransaccion,
                    "num_sec": 1
                }
            ]
        };
        return this.http.post<any>(`${config.apiUrl}/intspiopipend/comprobantes`, params)
            .toPromise()
            .then(res => <any>res.obj)
            .then(data => {
                return data;
            }).catch(res => this.alertService.error('Se ha producido un error Intente de nuevo'));
    }
}
